import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { SokusaiChangePasswordSentComponent } from './sokusai-change-password-sent/sokusai-change-password-sent.component';
import { SokusaiForgotPasswordComponent } from './sokusai-forgot-password/sokusai-forgot-password.component';
import { SokusaiInputComponent } from './sokusai-input/sokusai-input.component';
import { SokusaiLoginComponent } from './sokusai-login/sokusai-login.component';
import { SokusaiOemHeaderComponent } from './sokusai-oem-header/sokusai-oem-header.component';
import { SokusaiOemLoginMessageComponent } from './sokusai-oem-login-message/sokusai-oem-login-message.component';
import { SokusaiOemRegisterMessageComponent } from './sokusai-oem-register-message/sokusai-oem-register-message.component';
import { SokusaiPasswordInputComponent } from './sokusai-password-input/sokusai-password-input.component';
import { SokusaiRegisterResendComponent } from './sokusai-register-resend/sokusai-register-resend.component';
import { SokusaiRegisterSendComponent } from './sokusai-register-send/sokusai-register-send.component';
import { SokusaiRegisterComponent } from './sokusai-register/sokusai-register.component';
import { SokusaiResetPasswordComponent } from './sokusai-reset-password/sokusai-reset-password.component';
import { SokusaiUnblockComponent } from './sokusai-unblock/sokusai-unblock.component';
import { SokusaiComponent } from './sokusai/sokusai.component';
import { OemService } from './oem.service';

@NgModule({
  declarations: [
    SokusaiComponent,
    SokusaiLoginComponent,
    SokusaiRegisterComponent,
    SokusaiUnblockComponent,
    SokusaiRegisterResendComponent,
    SokusaiRegisterSendComponent,
    SokusaiForgotPasswordComponent,
    SokusaiResetPasswordComponent,
    SokusaiChangePasswordSentComponent,
    SokusaiInputComponent,
    SokusaiPasswordInputComponent,
    SokusaiOemHeaderComponent,
    SokusaiOemRegisterMessageComponent,
    SokusaiOemLoginMessageComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    SokusaiResetPasswordComponent,
    SokusaiComponent,
    SokusaiRegisterResendComponent,
    SokusaiRegisterSendComponent,
    SokusaiUnblockComponent,
    SokusaiChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SokusaiModule {}
